import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IImageWithTextProps } from '../components/image-with-text/image-with-text';
import { Models } from './index';

export class ImageWithTextModel extends ContentItem {
  get texts(): string {
    const items = get(this._config, 'elements.text.value', []);
    const modeledTexts = items.map((article: IText) =>
      Models.TextModel.create(article as IText)
    );
    return modeledTexts;
  }

  get image(): string {
    return get(this._config, 'elements.image.value[0]', {});
  }

  get reversed(): string {
    return get(this._config, 'elements.reversed.value[0].codename', false);
  }

  public static create(data: IText): IImageWithTextProps {
    const { texts, image, reversed } = new ImageWithTextModel(data);
    return {
      texts,
      image,
      reversed
    };
  }
}
